export function resolveMaasSystemConfigPaths(_prefix: string): Record<string, string> {
  return {};
}
